import {Component, Inject, Input, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {CommentService} from '@Common/widgets/general/comments/service/comment.service';
import {CommentModel} from '@Common/widgets/general/comments/interfaces/comment.model';
import {ListParameters} from '@Services/base/daoService';
import {SubSink} from '@Common/core/utils/subsink';
import {CommentTypeEnum} from '@Common/widgets/general/comments/interfaces/comment-type.enum';
import * as FileSaver from 'file-saver';
import {AttachmentService} from '@Common/widgets/general/attachments';
import {AttachmentModel} from '@Common/widgets/general/attachments/interfaces/attachment.model';
import {FileSizePipe} from '@Common/widgets/pipes/file-size';
import {finalize} from 'rxjs/operators';
import {Individu, IndividuService} from '@Common/core/services';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {MatDialog} from '@angular/material/dialog';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {CommentTriggerModel} from '@Common/widgets/general/comments/service/comment-trigger.model';

@Component({
  selector: 'p8-list-comments',
  templateUrl: './list-comments.component.html',
  styleUrls: ['./list-comments.component.scss']
})
export class ListCommentsComponent implements OnInit, OnDestroy {
  /**
   * L'objet concerné par le commentaire, son pk id : par exemple ResponseDemat
   * le pk de l'objet (par exemple ResponseDemat 24, Deposit 24, etc)
   */
  @Input() object_id: number;
  /**
   * le type de cet objet que Django historise dans la table django_content_type (par exemple ResponseDemat 261, Deposit 271)
   */
  @Input() content_type: number;
  /**
   * Option liste messages
   */
  @Input() canSeePrivate = false;
  @Input() canDeleteMessage = true;
  /**
   * Est-ce que l'auteur d'un message peut le supprimer ?
   */
  comments: CommentModel[] = [];
  typeMessage = CommentTypeEnum;
  commentsLoading = false;
  individuConnected: Individu;
  subSink = new SubSink();
  constructor(@Inject(LOCALE_ID) private locale: string,
              private dialog: MatDialog,
              private individuSvc: IndividuService,
              private snackSvc: SnackBarToastyService,
              private attchmentSvc: AttachmentService,
              private commentsSvc: CommentService) { }

  ngOnInit(): void {
    this.subSink.sink = this.individuSvc.individu$
      .subscribe(_individu => this.individuConnected = _individu);
    this.subSink.sink = this.commentsSvc.onCommentChanged$.subscribe(_ => this._fetchMessages());
    this._fetchMessages();
  }
  confirmDelete(comment: CommentModel) {
    const data = new DialogData();
    data.title = `Suppression de message`;
    data.iconType = 'warning';
    data.message = 'Supprimer ce message ?';
    data.buttonTextTrue = 'Supprimer';
    data.buttonTextFalse = 'Annuler';
    data.buttonColorTrue = 'primary';
    const dialogRef = this.dialog.open(DialogValidationComponent, { data: data });
    dialogRef.updatePosition({top: '50px'});
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.subSink.sink = this.commentsSvc
          .delete(comment)
          .subscribe(_ => {
            this.snackSvc.toasty('Message', 'Le message a bien été supprimé', typeToast.success);
            this._triggerDeletedComment(comment);
          });
      }
    });
  }
  isOwner(comment: CommentModel) {
    return this.individuConnected?.uid === comment.commentator;
  }
  fileToolTip(file: AttachmentModel) {
    const fileSize: FileSizePipe = new FileSizePipe(this.locale);
    return `Télécharger le fichier "${file.filename}" (${fileSize.transform(file.size, 2, this.locale)})`;
  }
  downloadFile(file: AttachmentModel) {
    this.subSink.sink = this.attchmentSvc.download(file).subscribe(v => FileSaver.saveAs(v, file.filename));
  }
  private _triggerDeletedComment(_comment) {
    const commentTrigger = <CommentTriggerModel> {
      comment: _comment,
      action: 'del'
    };
    this.commentsSvc.triggerComment(commentTrigger);
  }
  private _fetchMessages() {
    this.commentsLoading = true;
    const parameters = <ListParameters> {
      extraParams: new Map<string, string>([
        ['object_id', this.object_id.toString()],
        ['content_type', this.content_type.toString()]])
    };
    this.subSink.sink = this.commentsSvc
      .listItems(parameters)
      .pipe(finalize(() => this.commentsLoading = false))
      .subscribe(_comments => this.comments = _comments.list);
  }
  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
